import React, { Component } from 'react';
import fetchAPI from './../../utils/fetchAPI';
import { getVarConfig } from './../../utils/environment';
import { MainContext } from './../../MainContext';

import './Login.scss';

import MazTuInfoBeesButton from './../../components/maz-tu-info-bees/maz-tu-info-bees-button/MazTuInfoBeesButton';
import MazTuInfoBeesInput from './../../components/maz-tu-info-bees/maz-tu-info-bees-input/MazTuInfoBeesInput';

import TagManager from 'react-gtm-module';
import { escapeAccents } from '../../utils/utils';
import { RecuperarPasswd } from '../recuperarPasswd';
import { setCookie } from '../../utils/cookiesUtils';
import { Snackbar } from '@mui/material';
import Alert from '@mui/material/Alert';

export default class Login extends Component {
  static contextType = MainContext;

  state = {
    sessionID: '',
    errorInput: false,
    errorInputPhone: false,
    errorInputHelper: '',
    errorInputPhoneHelper: '',
    user: {},
    errorLogin: false,
    modalPassword: false,
    captchaToken: null,
    loginErrorMessage: '',
    successOpen: false,
  };

  resetCaptcha = () => {
    this.setState({ captchaToken: null });

    const widget = document.querySelector('.cf-turnstile');
    if (window.turnstile && widget) {
      window.turnstile.reset(widget);
    }
  };

  constructor(props) {
    super(props);
    this.getUserInfo = this.getUserInfo.bind(this);
  }

  componentDidMount() {
    window.onTurnstileSuccess = (token) => {
      this.setState({ captchaToken: token });
    };

    window.onTurnstileExpired = () => {
      this.setState({ captchaToken: null });
      this.props.handleToast({
        open: true,
        type: 'warning',
        message: 'El captcha expiró, verifica nuevamente',
      });
    };

    window.onTurnstileError = () => {
      this.setState({ captchaToken: null });
      this.props.handleToast({
        open: true,
        type: 'error',
        message: 'Error en el captcha, intenta de nuevo',
      });
    };
  }

  handleLoginAccess = () => {
    const userID = document.getElementById('txt-user').value;
    const userPhone = document.getElementById('txt-phone').value;

    if (!this.state.captchaToken) {
      this.props.handleToast({
        open: true,
        type: 'error',
        message: 'Por favor completa el captcha',
      });
      return;
    }

    if (userID !== '') {
      if (userPhone !== '') {
        if (userPhone?.length >= 10 && userPhone?.length <= 12) {
          this.props.setLoaderOpen(true);
          this.getUserInfo({ userID, userPhone });
        } else {
          this.setState({
            errorInputPhone: true,
            errorInputPhoneHelper: 'La contraseña debe tener de 10 a 12 dígitos',
          });
          this.resetCaptcha();
        }
      } else {
        this.setState({
          errorInputPhone: true,
          errorInputPhoneHelper: 'Escriba una contraseña',
        });
        this.resetCaptcha();
      }
    } else {
      this.setState({
        errorInput: true,
        errorInputHelper: 'Escriba un código de cliente',
      });
      this.resetCaptcha();
    }
  };

  getUserInfo = ({ userID, userPhone }) => {
    fetchAPI({
      service: getVarConfig({ key: 'REACT_APP_SERVICES_GET_CUSTOMER' }),
      protocol: 'POST',
      params: {
        customerId: userID,
        phone: userPhone,
        captchaToken: this.state.captchaToken,
      },
      skipAuth: true,
      callbackThen: this.handleLoginSuccess,
      callbackError: this.handleLoginError,
    });
  };

  handleLoginSuccess = (response) => {
    const user = response.data;
    const access_token = user.access_token;
    const expires = user.expires_in;
    localStorage.setItem('bearer', access_token);
    setCookie('bearer', access_token, { expires });
    if (typeof response.status !== 'undefined') {
      if (response.status === 'success') {
        const isTradeUser = user.permissions.some((e) => e.name === 'trade_customer' && e.active);
        const isCandidateUser = user.permissions.some((e) => e.name === 'trade_candidate' && e.active);
        if (isTradeUser || isCandidateUser) {
          this.props.setLoaderOpen(false);
          const userBees = {
            name: user.name,
            ID: user.customerId,
            drv: escapeAccents(user.drv),
            rfc: user.rfc,
            uen: user.uen,
            phone: user.phone,
            permissions: user.permissions,
            matriz: user.CustomerInfo ? user.CustomerInfo.payer_no : null,
            sucursal: user.CustomerInfo ? user.CustomerInfo.city : null,
            level: user.tradeData ? user.tradeData.level : null,
            clubLevel: user.tradeData ? user.tradeData.clubLevel : null,
            resultsSeen: user.tradeData ? user.tradeData.resultsSeen : null,
            isTradeUser,
            isCandidateUser,
            isBmax: user.isBmax,
            initiative: user.tradeData ? user.tradeData.initiative : null,
          };

          if (userBees.isBmax == 'CANDIDATE') {
            localStorage.setItem('bmaxLogin', 'logged');
          } else {
            localStorage.removeItem('bmaxLogin');
          }

          this.props.setUser(JSON.stringify(userBees));
          TagManager.dataLayer({
            dataLayer: {
              event: 'GAEvent',
              event_category: 'LogIn',
              event_action: 'Success',
              event_label: 'LoginAPI',
              userid: user.customerId,
              POC_name: user.name,
            },
            dataLayerName: 'PageDataLayer',
          });
        } else {
          this.props.setLoaderOpen(false);
          this.props.handleToast({
            open: true,
            type: 'error',
            message: 'No tiene permisos para acceder a la aplicación',
          });
          console.log('No tiene permisos para acceder a la aplicación');
        }

        try {
          if (isCandidateUser) {
            this.props.setPath('/programa-mercado');
          } else if (isTradeUser) {
            this.props.setPath('/dashboard');
          }
        } catch (e) {
          console.log(e);
        }
      }
    }
    this.resetCaptcha();
  };

  handleLoginError = (status, data) => {
    let message = '';

    if (status === 400) {
      message = data?.message || 'El captcha no es válido o expiró. Intenta nuevamente.';
    }

    if (status === 404) {
      message = 'Lo sentimos. Has introducido un número Grupo Modelo o teléfono incorrecto.';
    }

    if (status === 401 || status === 500) {
      message = 'Hubo un error al cargar la información, intenta nuevamente.';
    }

    this.setState({
      showLoginError: true,
      loginErrorMessage: message,
    });

    this.props.setLoaderOpen(false);
    this.resetCaptcha();
  };

  handleCloseAlert = () => {
    this.setState({ showLoginError: false });
  };

  render() {
    return (
      <div className="login">
        <div className="login__logo"></div>

        <div className="login__form">
          <MazTuInfoBeesInput
            textLabel={'Ingrese número Grupo Modelo'}
            textPlaceHolder={'Coloca acá'}
            id="txt-user"
            error={this.state.errorInput}
            textHelperLeft={this.state.errorInputHelper}
            type="number"
          />
          <MazTuInfoBeesInput
            textLabel={'Contraseña en BEES'}
            textPlaceHolder={'Coloca acá'}
            id="txt-phone"
            error={this.state.errorInputPhone}
            textHelperLeft={this.state.errorInputPhoneHelper}
            type="text"
            length={12}
            hidePhone={true}
          />
          <div
            className="cf-turnstile"
            data-sitekey={window.REACT_APP_TURNSTILE_SITE_KEY}
            data-callback="onTurnstileSuccess"
            data-expired-callback="onTurnstileExpired"
            data-error-callback="onTurnstileError"
          />
          <span
            style={{ marginBottom: 20, display: 'flex', marginLeft: 70 }}
            onClick={() => this.setState({ modalPassword: true })}
            className="mt-20 pb-20"
          >
            Recuperar contraseña
          </span>
          <div className="login__button">
            <MazTuInfoBeesButton handleClick={this.handleLoginAccess} textButton={'INGRESAR'} />
          </div>
        </div>
        {this.state.errorLogin ? (
          <div className="registry__footer">
            <button className="registry__footer__btn__help">¿Tuviste algún problema para ingresar?</button>
            <button className="registry__footer__btn__payment" onClick={() => this.props.setPath('/registro')}>
              DÉJANOS TUS DATOS
            </button>
          </div>
        ) : null}
        {this.state.modalPassword && (
          <RecuperarPasswd
            visible={this.state.modalPassword}
            onClose={(success) => {
              this.setState({ modalPassword: false });

              if (success) {
                this.setState({ successOpen: true });
              }
            }}
          />
        )}
        <Snackbar
          open={this.state.showLoginError}
          autoHideDuration={4000}
          onClose={this.handleCloseAlert}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert severity="error" onClose={this.handleCloseAlert}>
            {this.state.loginErrorMessage}
          </Alert>
        </Snackbar>
        <Snackbar
          open={this.state.successOpen}
          autoHideDuration={3000}
          onClose={() => this.setState({ successOpen: false })}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert
            onClose={() => this.setState({ successOpen: false })}
            severity="success"
            variant="filled"
            sx={{
              width: '100%',
              fontSize: '1rem',
              padding: '6px 12px',
              '& .MuiAlert-icon': {
                fontSize: '1.5rem',
              },
            }}
          >
            Contraseña actualizada correctamente
          </Alert>
        </Snackbar>
      </div>
    );
  }
}
